import { Component } from 'react';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap';
import withRouter from '../../../../hoc/withRouter';
import PageTitle from '../../../common/page-title';
import { getScanningDisabledOutlets } from '../../../../actions/outlet';
import DisabledScansTable from './disabled-scans-table';

class DisabledScansPage extends Component {
  componentDidMount() {
    const { dispatch, isTeamRoute } = this.props;
    const path = isTeamRoute ? 'team' : 'admin';

    dispatch(getScanningDisabledOutlets(path));
  }

  render() {
    const { isLoading } = this.props;

    return (
      <div className="container-fluid">
        <Row>
          <PageTitle>
            Scanning Disabled
          </PageTitle>
          {isLoading ? 'Loading...' : (
            <DisabledScansTable />
          )}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: !state.stores.fetched && state.stores.fetching,
  isTeamRoute: ownProps.location.pathname.includes('team'),
});

export default withRouter(connect(mapStateToProps)(DisabledScansPage));
